import { Alert, Collapse, IconButton } from '@mui/material';

import { type LogsType } from 'app/main/components/hooks/useLogs';
import useSettings from 'app/main/components/hooks/useSettings';
import Icon from 'app/main/components/Icon';

interface LogsAlertProps {
	logProps: LogsType;
}

export default function LogsAlert({ logProps }: LogsAlertProps) {
	const { t } = useSettings();

	return (
		<Collapse className="fixed right-0 z-999 m-16" in={logProps.showLogs} timeout="auto" unmountOnExit>
			<Alert
				classes={{
					root: 'pt-4 pb-4 leading-normal',
					message: 'self-center',
					icon: 'self-center',
					action: 'pt-0 self-center'
				}}
				variant="filled"
				severity="info"
				icon={<Icon icon="timetable" />}
				action={
					<IconButton size="small" color="inherit" onClick={logProps.switchShowLogs}>
						<Icon icon="close" />
					</IconButton>
				}
			>
				<b>{t('SYSTEMINFO_LOG_ALERT_TITLE')}</b> - {t('SYSTEMINFO_LOG_ALERT_SUBTITLE')}
			</Alert>
		</Collapse>
	);
}
